import script from "./DeviceList.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeviceList.vue?vue&type=script&setup=true&lang=ts"

import "./DeviceList.vue?vue&type=style&index=0&id=248f924c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-248f924c"]])

export default __exports__